<template>
    <!-- 列表部分 -->
    <div class="monthDateMode">
        <!-- 周模式 -->
        <div v-if="modle === 'week'" class="calendarTitle calendarWeekTitle ">
            <span class="weekDay label">时间轴</span>
            <div class="weekDay" v-for="(item,index) in weekData" :key="index">
                <div>{{item.dateStr}}</div>
                <div>{{item.weekName}}</div>
            </div>
        </div>
        <div v-if="modle === 'week'" class="calendarBody calendarWeekBody calendar-day flex">
            <div class="timeTitle">
                <div v-for="(item, index) in timeList" :key="index" class="mr-20">
                    <p class="title" :style="index === timeList.length - 1 ? 'margin: 0' : ''">{{item.time}}</p>
                </div>
            </div>
            <div class="timeTable">
                <div class="timeTableX flex" v-for="(res, residx) in timeList" :key="residx">
                    <div class="itemBox" v-for="(itm,idx) in weekData" :key="idx">
                        <div v-for="(item,index) in res['num'+(idx+1)]" :key="index">
                            <el-popover placement="right" width="300" trigger="hover" popper-class="calendar-popover">
                                <div class="content">
                                    <div class="flex ai-c">
                                        <p class="title">{{item.classname}}</p>
                                    </div>
                                    <p class="text">{{`${item.perioddate} (${item.week}) ${item.starttime}~${item.endtime}` }}</p>
                                    <p class="text">课程: {{item.classcoursename}}</p>
                                    <p class="text">老师: {{item.teachername ? item.teachername : '暂无老师'}}</p>
                                    <p v-if="item.periodmode === 2" class="text">教室: {{item.periodplace ? item.periodplace : '暂无教室'}}</p>
                                    <p class="text">校区: {{item.campusname ? item.campusname : '暂无校区'}}</p>
                                    <div class="flex ai-c btn">
                                         <span class="mr-10" @click="openClassDetail(item)">详情</span>
                                        <span v-if="item.status == 10 && nowDate < getTimeStr(item.perioddate+' '+item.starttime)" class="mr-10" @click="openClassEdit(item)">编辑</span>
                                        <span v-if="item.status == 10 && nowDate < getTimeStr(item.perioddate+' '+item.starttime) || item.status == 30"  class="mr-10" @click="del(item)">删除</span>
                                    </div>
                                </div>
                                 <div v-if="index<2" class="item pointer textEllipsis" slot="reference">
                                    {{item.classname}}
                                 </div>
                            </el-popover>
                        </div>
                        <el-popover
                            placement="bottom"
                            width="240"
                            trigger="click"
                            popper-class="calendar-popover-child"
                        >
                            <div v-for="(item,index) in res['num'+(idx+1)]" :key="index" >
                                <el-popover placement="right" width="300" trigger="hover" popper-class="calendar-popover">
                                    <div class="content">
                                        <div class="flex ai-c">
                                            <p class="title">{{item.classname}}</p>
                                        </div>
                                        <p class="text">{{`${item.perioddate} (${item.week}) ${item.starttime}~${item.endtime}` }}</p>
                                        <p class="text">课程: {{item.classcoursename}}</p>
                                        <p class="text">老师: {{item.teachername ? item.teachername : '暂无老师'}}</p>
                                        <p v-if="item.periodmode === 2" class="text">教室: {{item.periodplace ? item.periodplace : '暂无教室'}}</p>
                                        <p class="text">校区: {{item.campusname ? item.campusname : '暂无校区'}}</p>
                                        <div class="flex ai-c btn">
                                            <span class="mr-10" @click="openClassDetail(item)">详情</span>
                                            <span v-if="item.status == 10 && nowDate < getTimeStr(item.perioddate+' '+item.starttime)" class="mr-10" @click="openClassEdit(item)">编辑</span>
                                            <span v-if="item.status == 10 && nowDate < getTimeStr(item.perioddate+' '+item.starttime) || item.status == 30"  class="mr-10" @click="del(item)">删除</span>
                                        </div>
                                    </div>
                                    <div  class="item pointer textEllipsis" slot="reference">
                                        {{item.classname}}
                                    </div>
                                </el-popover>
                            </div>
                            <p class="moreItem"  slot="reference" >
                                <span v-if="res['num'+(idx+1)].length>2">还有 {{res['num'+(idx+1)].length - 2}} 项...</span>
                            </p>
                        </el-popover>
                    </div>
                </div>
            </div>
        </div>
        <!-- 月模式 -->
        <div v-if="modle != 'week'" class="calendarTitle">
            <span class="weekDay" v-for="(item,index) in weekData1" :key="index">{{item}}</span>
        </div>
        <div v-if="modle != 'week'" class="calendarBody">
            <div class="monthDay" :class="[item.desc === 'prv' || item.desc === 'next'?'otherMoNth': '', 
                changeDateStr === nowDateStr && item.value === changeDay ? 'noDateClass' : '']" v-for="(item,index) in showDayArray" :key="index">
                <div class="defaultBox" >
                    <span>{{item.value}}</span>
                </div>
                <div class="classNameBox">
                    <div v-for="(res,residx) in item.datalist" :key="residx" >
                        <el-popover v-show="item.datalist.length > 0"   placement="right" popper-class="calendar-popover" width="300" trigger="hover">
                                <div class="content mt-10">
                                    <div class="flex ai-c">
                                        <p class="title">{{res.classname}}</p>
                                    </div>
                                    <p>{{res.perioddate}} （{{res.week}}） {{res.starttime + '~' + res.endtime}}</p>

                                    <p class="text">课程: {{res.classcoursename}}</p>
                                    <p class="text">老师: {{res.teachername ? res.teachername : '暂无老师'}}</p>
                                    <p v-if="res.periodmode === 2" class="text">教室: {{res.periodplace ? res.periodplace : '暂无教室'}}</p>
                                    <p class="text">校区：{{res.campusname ? res.campusname : '暂无校区'}}</p>
                                    <div class="flex ai-c btn">
                                        <span class="mr-10" @click="openClassDetail(res)">详情</span>
                                        <span v-if="res.status == 10 && nowDate < getTimeStr(item.dateStr+' '+res.starttime)" class="mr-10" @click="openClassEdit(res,item)">编辑</span>
                                        <span v-if="res.status == 10 && nowDate < getTimeStr(item.dateStr+' '+res.starttime) || res.status == 30"  class="mr-10" @click="del(res)">删除</span>
                                    </div>
                                </div>
                            <div class="item pointer textEllipsis" v-if="residx < 3" slot="reference">
                                <span class="">{{res.classname}}</span>
                            </div>
                        </el-popover>
                    </div>
                    <el-popover
                        placement="bottom"
                        width="240"
                        trigger="click"
                        popper-class="calendar-popover-child"
                        >
                            <div v-for="(res,residx) in item.datalist" :key="residx" >
                                <el-popover v-show="item.datalist.length > 0"   placement="right" popper-class="calendar-popover" width="300" trigger="hover">
                                        <div class="content mt-10">
                                            <div class="flex ai-c">
                                                <p class="title">{{res.classname}}</p>
                                            </div>
                                            <p>{{res.perioddate}} （{{res.week}}） {{res.starttime + '~' + res.endtime}}</p>

                                            <p class="text">课程: {{res.classcoursename}}</p>
                                            <p class="text">老师: {{res.teachername ? res.teachername : '暂无老师'}}</p>
                                            <p v-if="res.periodmode === 2" class="text">教室: {{res.periodplace ? res.periodplace : '暂无教室'}}</p>
                                            <p class="text">校区：{{res.campusname ? res.campusname : '暂无校区'}}</p>
                                            <div class="flex ai-c btn">
                                                <span class="mr-10" @click="openClassDetail(res)">详情</span>
                                                <span v-if="res.status == 10 && nowDate < getTimeStr(item.dateStr+' '+res.starttime)" class="mr-10" @click="openClassEdit(res,item)">编辑</span>
                                                <span v-if="res.status == 10 && nowDate < getTimeStr(item.dateStr+' '+res.starttime) || res.status == 30" class="mr-10" @click="del(res)">删除</span>
                                            </div>
                                        </div>
                                    <div class="poverListBox textEllipsis" slot="reference">
                                        <p class="">{{res.classname}}</p>
                                    </div>
                                </el-popover>
                            </div>
                        <p class="moreItem" slot="reference">
                            <span v-if="item.datalist.length > 3">还有 {{item.datalist.length - 3}} 项...</span>
                        </p>
                    </el-popover>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { dateFormat2 } from '@/assets/measAssets/js/tools.js'
export default {
  data() {
    return {
      weekData: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      weekData1: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
      nowDay: '', //当前天
      nowMonth: '', //当前月
      nowYear: '', //当前年
      nowDateStr: '', //当前的年月日
      changeDay: '', //切换月份后的天
      changeMonth: '', //切换月份后的月
      changeYear: '', //切换月份后的年
      changeDateStr: '', //切换后的年月日
      month30: [1, 3, 5, 7, 8, 10, 12], //天数30天月份
      month31: [4, 6, 9, 11], //天数31天月份
      showDay: '', //当前的月份天数
      showDayArray: [], //每月显示的天数数组，包含上一月和下一月的
      prvMonth: '', //上月天数
      nextMonth: '', //下月天数
      weekTime: '',
      weekInfo: [],
      timeList1: [
        '08:00',
        '09:00',
        '10:00',
        '11:00',
        '12:00',
        '13:00',
        '14:00',
        '15:00',
        '16:00',
        '17:00',
        '18:00'
      ],
      defaultTimeList: [],
      timeList: [
        {
            time: '00:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '08:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '09:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '10:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '11:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '12:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '13:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '14:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '15:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '16:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '17:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '18:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '19:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '20:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '21:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '22:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
        {
            time: '24:00', num1: [],num2: [],num3: [],num4: [],num5: [],num6: [],num7: []
        },
      ],
      nowDate: new Date().getTime()
    }
  },
  props: ['info', 'modle', 'datalist'],
  created() {
    this.defaultTimeList = JSON.parse(JSON.stringify(this.timeList))
  },
  watch: {
    info: {
      handler(value) {
        if (value) {
          this.init()
        }
      },
      deep: true
    }
  },
  filters: {
    handleDate(dateStr) {
      return new Date(dateStr).getTime()
    }
  },
  methods: {
    getTimeStr(time){
        return new Date(time).getTime()
    },
    // handlerSetTime(item, res, residx){
    //     let flag = false
    //     let nowTime = this.getTimeStr(item.perioddate+' '+res.time)
    //     let nowTime1 = this.getTimeStr(item.perioddate+' '+item.starttime)
    //     if(nowTime <= nowTime1){
    //         flag = true
    //     }
    //     let flag1 = false
    //     let nowTimeT = this.getTimeStr(item.perioddate+' '+item.starttime)
    //     let nowTime1T = this.getTimeStr(item.perioddate+' '+(residx < this.timeList.length - 1 ? this.timeList[residx + 1].time : this.timeList[residx].time))
    //     if(nowTimeT<nowTime1T){
    //         flag1 = true
    //     }
    //     if(flag && flag1){
    //         return true 
    //     }
    // },
    // handlerSetTime1(item, res, residx){
    //     let flag = false
    //     let nowTime = this.getTimeStr(item.perioddate+' '+this.timeList[residx].time)
    //     let nowTime1 = this.getTimeStr(item.perioddate+' '+item.endtime)
    //     if(nowTime <= nowTime1){
    //         flag = true
    //     }
    //     let flag1 = false
    //     let nowTimeT = this.getTimeStr(item.perioddate+' '+item.starttime)
    //     let nowTime1T = this.getTimeStr(item.perioddate+' '+this.timeList[residx].time)
    //     if(nowTimeT<=nowTime1T){
    //         flag1 = true
    //     }
    //     if(flag && flag1){
    //         return true
    //     }
    // },
    init() {
      this.emptyData()
      this.getYear()
      this.getMonth()
      this.getDay()
      this.getNowMonth()
      this.upMonths()
      this.nextMonths()
      this.$nextTick(() => {
        this.getShowDays()
      })
      this.getNowWeek()
    },
    emptyData() {
      this.nowDay = ''
      this.nowMonth = ''
      this.nowYear = ''
      this.nowDateStr = ''
      this.changeDay = ''
      this.changeMonth = ''
      this.changeYear = ''
      this.changeDateStr = ''
      this.showDay = ''
      this.showDayArray = []
      this.prvMonth = ''
      this.nextMonth = ''
      this.weekData = ['周一', '周二', '周三', '周四', '周五', '周六', '周日']
    },
    // 获取当前年份
    getYear() {
      var nowYear = new Date().getFullYear()
      this.nowYear = nowYear
      this.changeYear = nowYear
    },
    // 获取当前月份
    getMonth() {
      var nowMonth = new Date().getMonth() + 1
      this.nowMonth = nowMonth
      this.changeMonth = nowMonth
    },

    // 获取当前号数
    getDay() {
      var nowDay = new Date().getDate()
      this.nowDay = nowDay
      this.changeDay = nowDay
      this.nowDateStr = this.nowYear + '-' + this.nowMonth + '-' + nowDay
      this.changeDateStr =
        this.changeYear + '-' + this.changeMonth + '-' + nowDay
      this.changeYM()
    },
    // 计算年份的月份天数
    getYearType(y, m) {
      var num
      if (y % 4 == 0) {
        // 二月天数为28
        num = 28
      } else {
        // 二月天数为29
        num = 29
      }
      if (m != 2) {
        if (this.month30.indexOf(m) !== -1) {
          num = 31
        } else {
          num = 30
        }
      }
      return num
    },
    getNowMonth() {
      this.showDay = this.getYearType(this.nowYear, this.nowMonth)
    },
    // 获取上一月的天数
    upMonths() {
      this.prvMonth = this.getYearType(this.nowYear, this.nowMonth - 1)
    },
    // 获取下一月的天数
    nextMonths() {
      this.nextMonth = this.getYearType(this.nowYear, this.nowMonth + 1)
    },
    // 显示上一个月的天数
    getPrvDay(num, all) {
      let tmpArr = []
      let dateStr = ''
      if (this.nowMonth == 1) {
        dateStr = this.nowYear - 1 + '-' + '12'
      } else {
        dateStr =
          this.nowYear +
          '-' +
          (this.nowMonth - 1 < 10
            ? '0' + (this.nowMonth - 1)
            : this.nowMonth - 1)
      }
      for (let i = num; i > all; i--) {
        tmpArr.push({
          value: i,
          desc: 'prv',
          datalist: [],
          dateStr: dateStr + '-' + (i < 10 ? '0' + i : i)
        })
      }
      tmpArr.forEach(item => {
        this.info.forEach(itm => {
          if (item.dateStr === itm.perioddate) {
            item.datalist = itm.datalist
          }
        })
      })
      this.showDayArray = [...tmpArr, ...this.showDayArray]
    },
    // 显示下一个月的天数
    getNextDay(num, all) {
      let tmpArr = []
      let dateStr = ''
      if (this.nowMonth == 12) {
        dateStr = this.nowYear + 1 + '-' + '01'
      } else {
        dateStr =
          this.nowYear +
          '-' +
          (this.nowMonth + 1 < 10
            ? '0' + (this.nowMonth + 1)
            : this.nowMonth + 1)
      }
      for (let i = num; i <= all; i++) {
        tmpArr.push({
          value: i,
          desc: 'next',
          datalist: [],
          dateStr: dateStr + '-' + (1 < 10 ? '0' + 1 : 1)
        })
      }
      tmpArr.forEach(item => {
        this.info.forEach(itm => {
          if (item.dateStr === itm.perioddate) {
            item.datalist = itm.datalist
          }
        })
      })
      this.showDayArray = [...this.showDayArray, ...tmpArr]
    },
    // 获取显示天数
    getShowDays() {
      let tmpArr = []
      for (let i = 1; i <= this.showDay; i++) {
        tmpArr.push({
          value: i,
          desc: '',
          datalist: [],
          dateStr:
            this.nowYear +
            '-' +
            (this.nowMonth < 10 ? '0' + this.nowMonth : this.nowMonth) +
            '-' +
            (i < 10 ? '0' + i : i)
        })
      }
      tmpArr.forEach(item => {
        this.info.forEach(itm => {
          if (item.dateStr === itm.perioddate) {
            item.datalist = itm.datalist
          }
        })
      })
      this.showDayArray = tmpArr
      var weekDay = this.oneDay(this.nowYear, this.nowMonth, 1)
      if (weekDay == 1) {
        this.getPrvDay(this.prvMonth, this.prvMonth)
        this.getNextDay(1, 35 - this.showDay - weekDay + 1)
      } else if (weekDay == 2) {
        this.getPrvDay(this.prvMonth, this.prvMonth - 1)
        this.getNextDay(1, 35 - this.showDay - weekDay + 1)
      } else if (weekDay == 3) {
        this.getPrvDay(this.prvMonth, this.prvMonth - 2)
        this.getNextDay(1, 35 - this.showDay - weekDay + 1)
      } else if (weekDay == 4) {
        this.getPrvDay(this.prvMonth, this.prvMonth - 3)
        this.getNextDay(1, 35 - this.showDay - weekDay + 1)
      } else if (weekDay == 5) {
        this.getPrvDay(this.prvMonth, this.prvMonth - 4)
        this.getNextDay(1, 42 - this.showDay - weekDay + 1)
      } else if (weekDay == 6) {
        this.getPrvDay(this.prvMonth, this.prvMonth - 5)
        this.getNextDay(1, 42 - this.showDay - weekDay + 1)
      } else if (weekDay == 0) {
        this.getPrvDay(this.prvMonth, this.prvMonth - 6)
        this.getNextDay(1, 42 - this.showDay - weekDay + 1)
      }
    },
    handleSetInfo() {},
    getMonday(dates) {
      //dates: 0本周,1下周,-1上周
      let arr = [],
        weekOne = ''
      let todayTimeStr = new Date(this.nowDateStr).getTime()
      var day = (new Date().getDay() - 1) * 24 * 60 * 60 * 1000
      if (dates == 0) {
        //本周
        weekOne = todayTimeStr - day //周一 0点的时间戳
      }
      // 一天的时间戳
      let dayTime = 24 * 60 * 60 * 1000
      if (dates == -1) {
        //上一周
        weekOne = this.weekTime - 7 * 24 * 60 * 60 * 1000
      } else if (dates == 1) {
        //下一周
        weekOne = this.weekTime + 7 * 24 * 60 * 60 * 1000
      }
      this.weekTime = weekOne
      for (let i = 0; i < 7; i++) {
        let timeOne_year = new Date(
          new Date(weekOne + i * dayTime)
        ).getFullYear()
        let timeOne_month =
          new Date(new Date(weekOne + i * dayTime)).getMonth() + 1 >= 10
            ? new Date(new Date(weekOne + i * dayTime)).getMonth() + 1
            : '0' + (new Date(new Date(weekOne + i * dayTime)).getMonth() + 1)
        let timeOne_date =
          new Date(new Date(weekOne + i * dayTime)).getDate() >= 10
            ? new Date(new Date(weekOne + i * dayTime)).getDate()
            : '0' + new Date(new Date(weekOne + i * dayTime)).getDate()
        arr.push(timeOne_year + '-' + timeOne_month + '-' + timeOne_date)
      }
      let tmpWeekDate = []
      this.weekData.forEach((weekItem, weekIdx) => {
            tmpWeekDate.push({
                dateStr: arr[weekIdx],
                weekName: weekItem,
                datalist: []
            })
      })
      this.weekInfo = arr
      this.weekData = tmpWeekDate
      //   return arr
    },
    changeWeek() {
        this.timeList = JSON.parse(JSON.stringify(this.defaultTimeList))
        this.info.forEach(item => {
            this.weekData.forEach(itm => {
                if(itm.dateStr === item.perioddate){
                    itm.datalist = item.datalist
                }
            })
        })
        let timeLine = this.timeList
        this.timeList.forEach(item => {

        })
        this.initWeekDate()
    },
    getNowWeek() {
      this.getMonday(0)
      this.changeWeek()
      this.$emit('getweek', this.weekInfo)
      console.log(this.weekInfo,'this.weekInfothis.weekInfothis.weekInfo')
    },
    getNextWeek() {
        this.weekData = this.weekData1
      this.getMonday(1)
      this.changeWeek()
      console.log(this.weekData,'this.weekDate')
      this.$emit('getweek', this.weekInfo)
    },
    getPrvWeek() {
        this.weekData = this.weekData1
      this.getMonday(-1)
      this.changeWeek()
      this.$emit('getweek', this.weekInfo)
    },
    initWeekDate() {
        this.weekData.forEach((itm,idx) => {
            itm.datalist.forEach((cItm,cIdx) => {
                this.timeList.forEach((res,resIdx) => {
                    if(
                        (this.getTimeStr(cItm.perioddate+' '+res.time) <= this.getTimeStr(cItm.perioddate+' '+cItm.starttime))
                        && this.getTimeStr(cItm.perioddate+' '+cItm.starttime) < this.getTimeStr(cItm.perioddate+' '+
                        (resIdx < this.timeList.length - 1 ? this.timeList[resIdx + 1].time : this.timeList[resIdx].time))
                        || (this.getTimeStr(cItm.perioddate+' '+this.timeList[resIdx].time) <= this.getTimeStr(cItm.perioddate+' '+cItm.endtime) 
                        && this.getTimeStr(cItm.perioddate+' '+cItm.starttime) <= this.getTimeStr(cItm.perioddate+' '+this.timeList[resIdx].time))
                    ){
                        res['num'+(idx+1)].push(cItm) 
                    }
                })
            })
        })
        console.log(this.timeList,'this.timeListthis.timeList')
    },
    //  计算时间差
    compareTime(time1, time2) {
      let arr1 = time1.split(':')
      let arr2 = time2.split(':')
      let min = 0
      min = Math.abs((arr1[0] - arr2[0]) * 60 + (arr1[1] - arr2[1]))
      return min
    },
    // 计算某一天是周几
    oneDay(y, m, d) {
      var myDate = new Date()
      myDate.setFullYear(y, m - 1, d)
      var week = myDate.getDay()
      switch (week) {
        case 0:
          return '0' //天
        case 1:
          return '1' //一
        case 2:
          return '2' //二
        case 3:
          return '3' //三
        case 4:
          return '4' //四
        case 5:
          return '5' //五
        case 6:
          return '6' //六
      }
    },
    // 切换到上一月
    changePrvM() {
      this.showDayArray = []
      this.nowMonth--
      if (this.nowMonth < 1) {
        this.nowMonth = 12
        this.nowYear--
      }
      this.getNowMonth()
      this.upMonths()
      this.nextMonths()
      this.getShowDays()
      this.nowDateStr = this.nowYear + '-' + this.nowMonth + '-' + this.nowDay
      this.changeYM()
    },
    // 切换到下一月
    changeNextM() {
      this.showDayArray = []
      this.nowMonth++
      if (this.nowMonth > 12) {
        this.nowMonth = 1
        this.nowYear++
      }
      this.getNowMonth()
      this.upMonths()
      this.nextMonths()
      this.getShowDays()
      this.nowDateStr = this.nowYear + '-' + this.nowMonth + '-' + this.nowDay
      this.changeYM()
    },
    changeYM() {
      this.$emit('getDate', this.nowMonth, this.nowYear)
    },
    // 业务逻辑代码，后面可以移除组件
    // 班级详情
    openClassDetail(value) {
      this.$router.push({ name: 'CoursePeriodDetail', query: { code: value.coursecode, classCode: value.classcode, coursePeriodCode: value.code } })
    },
    // 编辑班级 
    openClassEdit(res,item) {
        console.log(res,'res')
        // item.isShowPopover = false
        // res.isShowPopover = false
        this.$emit('editClass', res)
    },
    // 删除
    del(row){
        this.$emit('delCourse', row)

    },
    
  }
}
</script>
<style lang="scss">

.textEllipsis{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}
.calendar-popover-child{
    padding: 10px!important;
    .item {
        margin-bottom: 1px;
        line-height: 18px;
        font-size: 14px;
        }
        .item:hover{
        color: #0b75fa;
        }
        .moreItem {
        font-size: 12px;
        margin-top: 10px;
        cursor: pointer;
        color: #0b75fa;
    }
}
.calendar-popover {
  padding: 20px;
  box-sizing: border-box;
  .content {
    .title {
      font-size: 16px;
      font-weight: bold;
      color: #4d5560;
      margin-right: 10px;
    }
    .box {
      width: 48px;
      height: 23px;
      background: #ffffff;
      border-radius: 2px 2px 2px 2px;
      border: 1px solid #0b75fa;
      line-height: 23px;
      text-align: center;
      font-size: 12px;
      color: #0b75fa;
    }
    .text {
      font-size: 13px;
      color: #66717e;
      line-height: 25px;
    }
    .btn {
      span {
        width: 48px;
        height: 25px;
        background: #ffffff;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #e4e7ec;
        font-size: 12px;
        color: #66717e;
        text-align: center;
        line-height: 25px;
        cursor: pointer;
        margin-top: 20px;
      }
      span:hover {
        background: #0b75fa;
        color: #ffffff;
        cursor: pointer;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.mt-20 {
  margin-top: 20px;
}
::v-deep .calendar-popover {
//   padding: 20px;
  box-sizing: border-box;
}
.moreItem {
    font-size: 12px;
    margin-top: 10px;
    cursor: pointer;
    color: #0b75fa;
}
.poverListBox{
    p{
        cursor: pointer;
        margin-left: 10px;
        &:hover{
            color: #0b75fa;
        }
    }
}
.monthDateMode {
  .calendarWeekTitle {
    .label {
      width: 88px !important;
    }
  }
  .calendarTitle {
    height: 60px;
    background: #f0f4f8;
    font-size: 14px;
    color: #4d5560;
    display: flex;
    border: 1px solid #e4e7ec;
    border-right: none;
    align-items: center;
    justify-content: center;
    .weekDay {
      width: 14.28%;
    //   display: flex;
    //   justify-content: center;
      text-align: center;
      line-height: 20px;
    //   align-items: center;
      border-right: 1px solid #e4e7ec;
    }
  }
  .calendarBody {
    display: flex;
    width: 100%;
    flex-wrap: wrap;
    overflow: hidden;
    box-sizing: border-box;
    border-left: 1px solid #e4e7ec;
    .monthDay {
      height: 160px;
      width: 14.28%;
      background: white;
      font-size: 14px;
      color: #66717e;
      box-sizing: border-box;
      border: 1px solid #e4e7ec;
      border-left: none;
      .defaultBox {
        box-sizing: border-box;
        padding: 20px 20px;
      }
        .classNameBox {
            padding: 0 20px;
            box-sizing: border-box;
          .item {
            margin-bottom: 1px;
            line-height: 18px;
            font-size: 14px;
          }
          .item:hover{
            color: #0b75fa;
          }
          .moreItem {
            font-size: 12px;
            margin-top: 10px;
            cursor: pointer;
            color: #0b75fa;
          }
        }

    //   .box:hover {
    //     background: #0b75fa;
    //     color: white !important;
    //   }
    }
    .content {
      .title {
        font-size: 16px;
        font-weight: bold;
        color: #4d5560;
        margin-right: 10px;
      }
      .box {
        width: 48px;
        height: 23px;
        background: #ffffff;
        border-radius: 2px 2px 2px 2px;
        border: 1px solid #0b75fa;
        line-height: 23px;
        text-align: center;
        font-size: 12px;
        color: #0b75fa;
      }
      .text {
        font-size: 13px;
        color: #66717e;
        line-height: 25px;
      }
      .btn {
        span {
          width: 48px;
          height: 25px;
          background: #ffffff;
          border-radius: 2px 2px 2px 2px;
          border: 1px solid #e4e7ec;
          font-size: 12px;
          color: #66717e;
          text-align: center;
          line-height: 25px;
          cursor: pointer;
          margin-top: 20px;
        }
        span:hover {
          background: #0b75fa;
          color: #ffffff;
        }
      }
    }
  }
  .otherMoNth {
    background: #f6f6f6 !important;
  }
  .noDateClass {
    background: #0b75fa !important;
    color: white !important;
  }
  .calendarWeekTitle {
    .label {
      width: 88px !important;
    }
  }
  .calendarWeekBody {
    .timeTitle {
      width: 88px;
      padding: 20px;
      box-sizing: border-box;
      .title {
        color: #66717e;
        margin-bottom: 79px;
        line-height: 22px;
      }
    }
    .timeTable {
      margin-top: 30px;
      flex: 1;
      overflow: hidden;
      .timeTableX {
        border-top: 1px solid #e4e7ec;
        flex: 1;
        .itemBox {
            padding: 20px;
          height: 100px;
          box-sizing: border-box;
        //   margin-top: 6px;
          width: calc(100% / 7);
          border-right: 1px solid #e4e7ec;
          text-align: center;
          .item{
            margin-top: 6px;
          }
          .item:hover{
            color: #0b75fa;
          }
        }
      }
    }
  }
}
</style>